import React from "react";
import { useNavigate } from "react-router-dom";
import { resolveWidgetIcon } from "./widgetIcons";

const VARIANT_CLASSES = {
  primary: "bg-blue-600 text-white hover:bg-blue-700",
  danger: "bg-red-600 text-white hover:bg-red-700",
  ghost: "bg-transparent text-blue-600 border border-blue-600 hover:bg-blue-50",
  success: "bg-green-600 text-white hover:bg-green-700",
};

const SIZE_CLASSES = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-base",
};

const ICON_SIZES = { sm: 14, md: 16, lg: 18 };

const ButtonLinkWidget = ({ widget, resolveSlugPath }) => {
  const navigate = useNavigate();
  const props = widget.props || {};
  const classes = VARIANT_CLASSES[props.style] || VARIANT_CLASSES.primary;
  const sizeClasses = SIZE_CLASSES[props.size] || SIZE_CLASSES.md;
  const Icon = props.icon ? resolveWidgetIcon(props.icon) : null;

  const handleClick = () => {
    if (props.target_slug) {
      navigate(resolveSlugPath(props.target_slug));
    } else if (props.target_path) {
      navigate(props.target_path);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-2 rounded-md font-semibold transition ${sizeClasses} ${classes}`}
    >
      {Icon && <Icon size={ICON_SIZES[props.size] || ICON_SIZES.md} />}
      {props.label || widget.title || "Continue"}
    </button>
  );
};

export default ButtonLinkWidget;
